import { Button } from '@workspace/ui/components/Button'

export function LoadMoreButton({ onPress, title, loading }: { onPress: () => void; title: string; loading?: boolean }) {
    return (
        <Button
            variant="unstyled"
            className="flex items-center p-0 text-neutral-500 font-normal leading-5 text-xs
        hover:text-primary active:text-primary mt-2 h-4 disabled:opacity-50
        "
            onPress={onPress}
            isDisabled={loading}
        >
            {loading ? 'Đang tải...' : `+ Xem thêm ${title}`}
        </Button>
    )
}
